import {INIT_STATE, UPDATE_APP_CLICK_TIME, UPDATE_APP_POSITION} from "../redux_constants/morpheus.state.constant";
import {get, get_response} from "../helper/request";

/**
 * @deprecated
 * [Priyanshu]
 */
export const updateAppPosition = (appName, position, allAppsState, urlState) => dispatch => {

    if ((urlState.app_state['present_app'] || {}).code !== undefined) {
        setUpdatedAppStatePresentMode(appName, 'position', position, urlState);
    }

    dispatch({
        type: UPDATE_APP_POSITION,
        appPosition: position,
        appName: appName
    });
}

/**
 * @deprecated
 * [Priyanshu]
 */
export const updateAppClickTime = (appName, urlState) => dispatch => {

    if ((urlState.app_state['present_app'] || {}).code !== undefined) {
        let allAppStates = urlState.app_state;
        let currentAppState = allAppStates[appName] || {};
        let newAppState = Object.assign({}, allAppStates, {
            [appName]: Object.assign({}, currentAppState, {
                clicked_at: new Date().getTime()
            })
        });

        let appVsClickTime = [];

        for (let key in newAppState) {
            appVsClickTime.push({
                key: key,
                val: newAppState[key].clicked_at === undefined ? 0 : newAppState[key].clicked_at
            })
        }

        appVsClickTime = appVsClickTime.sort(function (a, b) {
            return a.val - b.val;
        });

        appVsClickTime.map((item, index) => {
            newAppState[item.key].zIndex = 9 + 2 * index;
        })

        let returnableState = Object.assign({}, urlState, {
            app_state: newAppState
        });

        let url = `/api/set_sync_browsing/?sync_code=${returnableState.app_state.present_app.code}&morphle_id=${returnableState.slide_morphle_id}&angle=${returnableState.r}&zoom=${returnableState.z}&center_x=${returnableState.x}&center_y=${returnableState.y}&app_state=${JSON.stringify(returnableState.app_state)}`;
        get(url)
            .then(response => {
            })
            .catch(err => {
                console.log("Failed Setting Key Value");
            });
    }

    dispatch({
        type: UPDATE_APP_CLICK_TIME,
        appName: appName
    });
}

/**
 * @deprecated
 * [Priyanshu]
 */
export const loadMorpheusSettings = () => dispatch => {
    let url = `/api/morpheus/settings/` + JSON.parse(localStorage.getItem('morpheus_setting')).id + `/`;
    get_response(url)
        .then(response => {
            if (response.status === 200) {
                response.data.apps_initialised = true;
                dispatch({
                    type: INIT_STATE,
                    urlState: response.data
                })
            } else {
                console.log(response);
            }
        })
        .catch(err => {
            console.log(err);
        })
}

/**
 * @deprecated
 * [Priyanshu]
 */
export const setUpdatedAppStatePresentMode = (appName, key, value, urlState) => {
    let allAppStates = urlState.app_state;
    let currentAppState = allAppStates[appName] || {};
    let newAppState = Object.assign({}, allAppStates, {
        [appName]: Object.assign({}, currentAppState, {
            [key]: value
        })
    });
    let returnableState = Object.assign({}, urlState, {
        app_state: newAppState
    });

    let url = `/api/set_sync_browsing/?sync_code=${returnableState.app_state.present_app.code}&morphle_id=${returnableState.slide_morphle_id}&angle=${returnableState.r}&zoom=${returnableState.z}&center_x=${returnableState.x}&center_y=${returnableState.y}&app_state=${JSON.stringify(returnableState.app_state)}`;
    get_response(url)
        .then(response => {
        })
        .catch(err => {
            console.log("Failed Setting Key Value");
        });
}
